/*=========================================================================================
  File Name: getters.js
  Description: Vuex Store - getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

// added so later we can keep breakpoint in sync automatically using this config file
// import tailwindConfig from "../../tailwind.config.js"

const getters = {
  // COMPONENT
  // vx-autosuggest
  // starredPages: state => state.navbarSearchAndPinList.data.filter((page) => page.highlightAction),
  windowBreakPoint: (state) => {
    // This should be same as tailwind. So, it stays in sync with tailwind utility classes
    if (state.windowWidth >= 1200) return "xl";
    else if (state.windowWidth >= 992) return "lg";
    else if (state.windowWidth >= 768) return "md";
    else if (state.windowWidth >= 576) return "sm";
    else return "xs";
  },
  bodyOverlay: (state) => {
    return state.bodyOverlay;
  },
  verticalNavMenuItemsMin: (state) => {
    return state.verticalNavMenuItemsMin;
  },
  isVerticalNavMenuActive: (state) => {
    return state.isVerticalNavMenuActive;
  },
  AppActiveUser: (state) => {
    return state.AppActiveUser;
  },
  starredPages: (state) => {
    return state.starredPages;
  },
  navbarSearchAndPinList: (state) => {
    return state.navbarSearchAndPinList;
  },
  verticalNavMenuWidth: (state) => {
    return state.verticalNavMenuWidth;
  },
  scrollY: (state) => {
    return state.scrollY;
  },
  reduceButton: (state) => {
    return state.reduceButton;
  },
  mainLayoutType: (state) => {
    return state.mainLayoutType;
  },
  windowWidth: (state) => {
    return state.windowWidth;
  },
  theme: (state) => {
    return state.theme;
  },
  themePrimaryColor: (state) => {
    return state.themePrimaryColor;
  },
  isUserLoggedIn: (state) => {
    return state.isUserLoggedIn();
  },
  userInfo: (state) => {
    const userInfo = state.userInfo;
    return userInfo ? JSON.parse(userInfo) : null;
  },
  newUserInfo: (state) => {
    const userInfo = state.userInfo;
    return state.userInfo || null;
  },
  personalityRiskType: (state) => {
    return state.userInfo ? state.userInfo.personalityRiskType : null;
  },
  accountInfo: (state) => {
    const accountInfo = state.accountInfo;
    return accountInfo ? JSON.parse(accountInfo) : null;
  },
  userId: (state) => {
    return state.accountInfo && state.accountInfo.userInfo
      ? state.accountInfo.userInfo.userId
      : null;
  },
  sejamVerified: (state) => {
    return state.userInfo.sejamVerified;
  },
  userStatus: (state) => {
    return state.accountInfo.userStatus;
  },
  authToken: (state) => {
    const token = state.authToken;
    return token;
  },
  refreshToken: (state) => {
    return state.refreshToken;
  },
  userStep: () => {
    return localStorage.getItem("userStep");
  },

  tokenExpired: (state) => {
    return state.tokenExpired;
  },

  currentTicket: (state) => {
    return state.currentTicket;
  },

  categories: (state) => {
    return state.categories;
  },

  UserExistError: (state) => {
    return state.UserExistError;
  },
  Reference: (state) => {
    return state.ref;
  },
};

export default getters;
